import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/it/banner-circle-lines.png")